import { Component, ViewChild, NgZone, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { ModalDirective } from 'ngx-bootstrap/modal';

import {
    DocumentService,
    EquipmentService,
    AssociationService,
    EquipmentDocuments,
    PoweredByService,
    EquivalentTranslatedLanguage,
    Equipment,
    PoweredBy,
    Document
} from './../../../../shared/index';

@Component({
    selector: 'recommended',
    templateUrl: './recommended.html',
    standalone: false
})

export class RecommendedComponent implements OnInit, OnDestroy {
    @ViewChild('recommendedDocuments') modal: ModalDirective
    @ViewChild('modConfirmation') modConfirm: ModalDirective
    @ViewChild('modConfirmDelete') modDelete: ModalDirective
    public equipment: Equipment = new Equipment();
    public poweredBy: PoweredBy = new PoweredBy();
    public documents: Document[] = [];
    public recommended: Document[] = [];

    private recommendedSelected: number[] = [];
    private associatedSelected: number[] = [];

    private subscriptions: Subscription[] = [];
    public languages: EquivalentTranslatedLanguage[] = [];

    //public baseLanguage: string = "EN - English";
    public selectedLanguage = '';


    constructor(
        private _ngZone: NgZone,
        private _documentService: DocumentService,
        private _equipmentService: EquipmentService,
        private _associationService: AssociationService,
        private _poweredByService: PoweredByService
    ) {
        this.subscriptions.push(this._documentService.equipmentDocumentChange.subscribe((equipmentDocuments: EquipmentDocuments) => {
            this._ngZone.run(() => {
                this.documents = equipmentDocuments.Documents;
            });
        }));

        this.subscriptions.push(this._documentService.recommendedDocumentsChange.subscribe((equipmentDocuments: EquipmentDocuments) => {
            this._ngZone.run(() => {
                this.recommended = equipmentDocuments.Documents;
            });
        }));

        this.subscriptions.push(this._equipmentService.showRecommended.subscribe((equipment: Equipment) => {
            this.equipment = equipment;
            this.poweredBy = this._poweredByService.poweredBys.GetByMap(0, this.equipment.PoweredById);
            this.recommendedSelected = [];
            this.associatedSelected = [];
            this._documentService.getRecommended(this.equipment.Id);
            this._documentService.getEquivalentTranslatedLanguage(this.equipment.Id);
            this._documentService.getEquipmentDocuments(this.equipment.Id);
            this.modal.show();
        }));

        this.subscriptions.push(this._associationService.documentsAssociated.subscribe((info: boolean) => {
            if (this.modal.isShown) {
                this._documentService.getRecommended(this.equipment.Id);
                this._documentService.getEquivalentTranslatedLanguage(this.equipment.Id);
                this._documentService.getEquipmentDocuments(this.equipment.Id);
            }
        }));

        this.subscriptions.push(this._documentService.equivalentTranslatedDocumentAssociated.subscribe((info: boolean) => {
            if (this.modal.isShown && info == true) {
                this._documentService.getEquivalentTranslatedLanguage(this.equipment.Id);
                this._documentService.getEquipmentDocuments(this.equipment.Id);
                this._documentService.getDocumentCountForEquipment(this.equipment.Id)
                this.modConfirm.hide();
            }
        }));

        this.subscriptions.push(this._documentService.equivalentTranslatedDocumentDeleted.subscribe((info: boolean) => {
            if (this.modal.isShown && info == true) {
                this._documentService.getEquivalentTranslatedLanguage(this.equipment.Id);
                this._documentService.getEquipmentDocuments(this.equipment.Id);
                this._documentService.getDocumentCountForEquipment(this.equipment.Id)
                this.modDelete.hide();
            }
        }));

        this.subscriptions.push(this._documentService.equivalentTranslatedLanguagesChange.subscribe((languages: EquivalentTranslatedLanguage[]) => {
            this._ngZone.run(() => {
                this.languages = languages;
            });
        }));

        this.subscriptions.push(this._equipmentService.baseLanguageChange.subscribe((equipment: Equipment) => {
            this.equipment = equipment;
            //this.poweredBy = this._poweredByService.poweredBys.GetByMap(0, this.equipment.PoweredById);
            //this.recommendedSelected = [];
            //this.associatedSelected = [];
            //this._documentService.getRecommended(this.equipment.Id);
            //this._documentService.getEquivalentTranslatedLanguage(this.equipment.Id);
            //this._documentService.getEquipmentDocuments(this.equipment.Id);
            //this.modal.show();
        }));

        this._poweredByService.getPoweredBys();

    }

    public close(): void {
        this.modal.hide();
    }

    public isRecommendedSelected(documentId: number): boolean {
        return this.recommendedSelected.filter((value, index) => {
            return value == documentId;
        }).length > 0;
    }

    public isAssociatedSelected(documentId: number): boolean {
        return this.associatedSelected.filter((value, index) => {
            return value == documentId;
        }).length > 0;
    }

    public selectAllRecommended(): void {
        for (const document of this.recommended) {
            this.recommendedSelected.push(document.Id);
        }
    }

    public selectAllAssociated(): void {
        for (const document of this.documents) {
            this.associatedSelected.push(document.Id);
        }
    }

    public selectRecommended(documentId: number): void {
        if (this.recommendedSelected.find((value) => value == documentId)) {
            const temp: number[] = [];
            for (const docId of this.recommendedSelected) {
                if (docId != documentId) {
                    temp.push(docId);
                }
            }
            this.recommendedSelected = temp;
        } else {
            this.recommendedSelected.push(documentId);
        }
    }

    public selectAssociated(documentId: number): void {
        if (this.associatedSelected.find((value) => value == documentId)) {
            const temp: number[] = [];
            for (const docId of this.associatedSelected) {
                if (docId != documentId) {
                    temp.push(docId);
                }
            }
            this.associatedSelected = temp;
        } else {
            this.associatedSelected.push(documentId);
        }
    }

    public removeSelected(): void {
        this._associationService.removeDocumentAssociations(this.equipment.Id, this.associatedSelected);
    }

    public associateSelected(): void {
        this._associationService.associateDocumentsToEquipment(this.equipment.Id, this.recommendedSelected);
    }

    public languageChecked(e: any): void {
        if (e.target.checked) {

            this.modConfirm.show();
            this.selectedLanguage = e.target.defaultValue;
        }
    }

    public baseLanguageChange(baseLang: string): void {
        this._equipmentService.updateBaseLanguage(this.equipment.Id, baseLang);
    }

    public confirmYes(): void {
        this._documentService.addEquivalentTranslated(this.equipment.Id, this.selectedLanguage.substr(0, 2), this.equipment.BaseLanguage.substr(0, 2));
    }

    public confirmCancel(): void {
        this.modConfirm.hide();

        // reset the available Language
        this._documentService.getEquivalentTranslatedLanguage(this.equipment.Id);

        this.selectedLanguage = '';
    }

    public clearLangDocuments(clearLang: any): void {
        this.selectedLanguage = clearLang;
        this.modDelete.show();
    }

    public confirmDeleteYes(): void {
        this._documentService.delEquivalentTranslated(this.equipment.Id, this.selectedLanguage.substr(0, 2));
    }

    public confirmDeleteCancel(): void {
        this.modDelete.hide();

        // reset the available Language
        this._documentService.getEquivalentTranslatedLanguage(this.equipment.Id);

        this.selectedLanguage = '';
    }


    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
